import * as Types from '../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ConfiguratorResolvedTextureRevisionFragment = { __typename: 'ConfiguratorTextureRevision', displacement?: number | null, height: number, id: string, legacyId: number, width: number, texture?: { __typename: 'ConfiguratorTextureRevisionTexture', type: Types.TextureType } | null, dataObject: { __typename: 'ConfiguratorTextureRevisionDataObject', id: string, legacyId: number } };

export type ConfiguratorResolveTextureRevisionsQueryVariables = Types.Exact<{
  ids?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type ConfiguratorResolveTextureRevisionsQuery = { __typename: 'Query', configuratorTextureRevisions: Array<{ __typename: 'ConfiguratorTextureRevision', displacement?: number | null, height: number, id: string, legacyId: number, width: number, texture?: { __typename: 'ConfiguratorTextureRevisionTexture', type: Types.TextureType } | null, dataObject: { __typename: 'ConfiguratorTextureRevisionDataObject', id: string, legacyId: number } }> };

export type ConfiguratorResolveTextureRevisionsLegacyQueryVariables = Types.Exact<{
  legacyIds?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
}>;


export type ConfiguratorResolveTextureRevisionsLegacyQuery = { __typename: 'Query', configuratorTextureRevisions: Array<{ __typename: 'ConfiguratorTextureRevision', displacement?: number | null, height: number, id: string, legacyId: number, width: number, texture?: { __typename: 'ConfiguratorTextureRevisionTexture', type: Types.TextureType } | null, dataObject: { __typename: 'ConfiguratorTextureRevisionDataObject', id: string, legacyId: number } }> };

export const ConfiguratorResolvedTextureRevisionFragmentDoc = gql`
    fragment ConfiguratorResolvedTextureRevision on ConfiguratorTextureRevision {
  displacement
  height
  id
  legacyId
  width
  texture {
    type
  }
  dataObject {
    id
    legacyId
  }
}
    `;
export const ConfiguratorResolveTextureRevisionsDocument = gql`
    query configuratorResolveTextureRevisions($ids: [ID!]) {
  configuratorTextureRevisions(ids: $ids) {
    ...ConfiguratorResolvedTextureRevision
  }
}
    ${ConfiguratorResolvedTextureRevisionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorResolveTextureRevisionsGQL extends Apollo.Query<ConfiguratorResolveTextureRevisionsQuery, ConfiguratorResolveTextureRevisionsQueryVariables> {
    override document = ConfiguratorResolveTextureRevisionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfiguratorResolveTextureRevisionsLegacyDocument = gql`
    query configuratorResolveTextureRevisionsLegacy($legacyIds: [Int!]) {
  configuratorTextureRevisions(legacyIds: $legacyIds) {
    ...ConfiguratorResolvedTextureRevision
  }
}
    ${ConfiguratorResolvedTextureRevisionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorResolveTextureRevisionsLegacyGQL extends Apollo.Query<ConfiguratorResolveTextureRevisionsLegacyQuery, ConfiguratorResolveTextureRevisionsLegacyQueryVariables> {
    override document = ConfiguratorResolveTextureRevisionsLegacyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }